export default __webpack_public_path__ + "static/media/ico_close.e20279ac.svg";